var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelReddit14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M11.55 7a.941.941 0 0 0-1.61-.665c-.665-.455-1.54-.735-2.52-.77l.49-2.205 1.54.35c0 .455.385.84.84.84s.84-.385.84-.84-.385-.84-.84-.84a.82.82 0 0 0-.735.455L7.84 2.94c-.105-.035-.21.035-.245.14l-.56 2.485c-1.015.035-1.89.315-2.59.77A.941.941 0 0 0 2.835 7c0 .385.21.7.525.84-.035.14-.035.28-.035.42 0 1.435 1.715 2.59 3.85 2.59s3.85-1.155 3.85-2.59c0-.14 0-.28-.035-.42.35-.14.56-.455.56-.84m-6.65.945c0-.455.385-.84.84-.84s.84.385.84.84-.385.84-.84.84-.84-.385-.84-.84m4.06 1.96c-.525.525-1.365.56-1.96.56s-1.435-.035-1.96-.56c-.105-.105-.105-.245 0-.35s.245-.105.35 0c.385.385 1.05.49 1.61.49s1.225-.105 1.61-.49c.105-.105.245-.105.35 0s.105.245 0 .35m-.7-1.12a.85.85 0 0 1-.84-.84c0-.455.385-.84.84-.84s.84.385.84.84-.385.84-.84.84"
}))));
export default SvgChannelReddit14;